<td class="font-medium">{{ slice?.sliceNumber }}</td>
<td class="font-medium">{{ slice?.dueDate | date : 'dd.MM.yy' : undefined : facade.translate.currentLang + '-BE' }}</td>
<td class="font-medium">{{ slice?.amount | currency : 'EUR' }}</td>
<td><app-payment-status [slice]="slice"></app-payment-status></td>
